var lists_default = {
  "fontElementMap": "_54oGv",
  "orderedlist": "vo0Ka",
  "bulletedlist": "yHKSd",
  "listItem": "SJjvN"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
